export enum KeplerPointType {
  CategoryCompleted = 0,
  SkillsGapReport = 1,
  JourneyCompleted = 2,
  LoginStreak = 3,
  LevelAchieved = 4,
  ActivityCompleted = 5, // not used
  SkillScorePostAssessmentUpdated = 6,
  CareerPathAssessment = 7, // not used
  VariationQuestionReady = 8, // not used
  OffPlatformLearning = 9, // not used
  SkillScorePreAssessmentUpdated = 10,
}
